
<template>
  <div >
    <div  class="content"  v-for="(item, index) in tieZiObj.data" :key="index" >
      <div class="content-item" @click="openDetail(item.id)">
        <div class="top" style="padding-top: 10px">
          <div class="headPortrait" ><img src="../assets/user.png" alt=""></div>
          <div class="baseInfo" >
            <div class="nameAndTime">
              <span class="name">{{item.userName  }}</span>
              <span class="time">{{item.createTime| formatDate}}</span>
            </div>
            <div class="typeAndTitle">
              <span  v-if="item.tieziType===1" class="type" style="background: #EC971F">投诉</span>
              <span  v-if="item.tieziType===2 " class="type" style="background: #E9DC51">建议</span>
              <span  v-if="item.tieziType===3 " class="type"style="background: #25A597">咨询</span>
              <span  v-if="item.tieziType===4 " class="type">表扬</span>
              <span class="title" >
                  {{item.title}}
                </span>
            </div>
          </div>
        </div>
        <div class="center">
          <span  class="sizeStyle" >发帖内容:</span>{{item.content}}
        </div>

    <!--    <ul class="imgShow"  v-if="item.image !=null">
          <li v-for="(url,idx) in item.image.split(';')" :key="idx">
            <div class="imgShow-item">
              <img :src="getImgUrl(url)">
            </div>
          </li>
        </ul>-->
        <div class="imgShow"  v-if=" item.image != null">
          <div class="imgShow-item"  v-for="(url,idx) in item.image.split(';')" :key="idx">
            <img :src="getImgUrl(url) ">
          </div>
        </div>

        <div class="bottom1">
          <div class="classify">

            {{item.serviceItemName}}/{{item.serviceItemIdName}}
          </div>
          <div class="option">
            <div class="browse">
              浏览:<span  v-if="item.browseCount===null" class="browseCount">0</span>
              <span  v-else class="browseCount">{{item.browseCount}}</span>
              &nbsp;&nbsp;
              <span  class="iconfont aliaixin" style="position:relative;top:1px;"></span>
              <span v-if="item.greatCount===null" class="greatCount">0</span>
              <span  v-else class="greatCount">{{item.greatCount}}</span>
              &nbsp;&nbsp;
              <span class="iconfont alipinglun1" style="position:relative;top:1px;"></span>
              <span v-if="item.replyCount===null" class="replyCount">0</span>
              <span  v-else class="replyCount">{{item.replyCount}}</span>
              &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Toast,MessageBox} from 'mint-ui';
  import {getNewestTieZi,getByTieZiType,getByLikeTitleOrContent,getBrowseCount,getUnCensorPostAll,getUnCensorPostByType,OK,HOST} from '../api/data.js'

  import adminDetail from './adminDetail'
  import moment from 'moment'
  export default {
    data() {
      return {
        tieZiType:"0",
        tieZiTemp:[],
      }
    },
    components:{
      adminDetail

    },
    filters: {
      formatDate: function (value) {
        return moment(value).format('YYYY-MM-DD HH:mm')
      },
      hideMiddle(val) {
        return `${val.substring(0,1)}**`
      }
    },
    computed: {
      tieZiObj: {
            get: function(){
              return this.tieZiTemp; // 在这里把临时对象的值通过计算属性赋值给页面中用到的对象
            },
        },
    },
    //页面加载调用
    mounted() {
      this.getUnCensorPost(this.tieZiType);
    },
    methods: {
      getImgUrl(imageUrl){
        return HOST+imageUrl;
      },

      //未审核的帖子(可以按照服务类型进行筛选)
      getUnCensorPost(value){
        if(value==0){
          //获取所有未审核的帖子
          getUnCensorPostAll().then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                if (res.data.data.length===0) {
                  Toast('暂无未审核的帖子')
             /*     this.$toast.fail({
                    message: '暂无评论',
                    duration:2000
                  })*/
                }
                this.tieZiTemp=res.data ; // 在这里用临时变量接受服务端返回值

              }else{
                Toast('获取帖子失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else{
          //根据选择的服务类型进行筛选未审核的帖子
          getUnCensorPostByType(value).then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                this.tieZiTemp=[];
                this.tieZiTemp=res.data ; // 在这里用临时变量接受服务端返回值

              }else{
                Toast('获取帖子失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }
      },

      //审核的帖子(可以按照服务类型进行筛选)
      getServiceType(value){
        if(value==0){  //获取所有已审核的帖子
          getNewestTieZi().then(res=>{
            if(res.status === OK) {
              if(res.data.success==true){
                this.tieZiTemp=res.data ; // 在这里用临时变量接受服务端返回值
              }else{
                Toast('获取帖子失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }else{
          getByTieZiType(value).then(res=>{ //根据选择的服务类型进行筛选已审核的帖子
            if(res.status === OK) {
              if(res.data.success==true){
                this.tieZiTemp=[];
                this.tieZiTemp=res.data; // 在这里用临时变量接受服务端返回值

              }else{
                Toast('获取帖子失败')
              }
            }
          }).catch(error=>{
            console.log("错误"+error);
          })
        }
      },

      getByLikeTitleOrContent(value){// 根据标题或者帖子内容关键字搜索
        getByLikeTitleOrContent(value).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){
              this.tieZiTemp=[];
              this.tieZiTemp=res.data ; // 在这里用临时变量接受服务端返回值
              if(this.tieZiTemp.data.length==0){
                Toast('暂无数据')
              }
            }else{
              Toast('获取帖子失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })
      },
      onClick (index) {
        if(index==2){
          this.$router.push({name: "more"});

        }
      },
      openDetail(value){
        //浏览数加1
        getBrowseCount(value).then(res=>{
          if(res.status === OK) {
            if(res.data.success==true){

              // Toast('浏览成功')
            }else{
              //Toast('浏览失败')
            }
          }
        }).catch(error=>{
          console.log("错误"+error);
        })

        this.$router.push({path:'/adminDetail',
          query: {
            tieZiId: value
          }})

      }
    },

  }
</script>

<style lang="scss" scoped>
  .content{
    font-size:0.8rem;
    color:gray;
    .content-item{
      border-bottom:1px solid lightgray;
      padding:0.8rem 0.5rem;
      .top{
        display:flex;
        .headPortrait{
          margin-right: 0.3rem;
          img{
            width: 2rem;
            height:2rem;
          }
        }
        .baseInfo{
          padding:1px 0;
          .nameAndTime{
            text-align:left;
            overflow: hidden;
            .name{
              margin-right:2rem;
            }
            .time{

            }
          }
          .typeAndTitle{
            overflow:hidden;
            .type{
              padding:0.1rem 0.5rem;
              color:white;
              background:#4caf50;
              border-radius: 10%;
              margin-right:1rem;
              font-weight:lighter;
            }
            .title{
              color:black;
            }
          }
        }
      }
      .center{
        padding:0.5rem;
        text-align:left;
        .imgShow{
          display:flex;

          align-items: center;
          justify-content: space-around;


        }
      }
      .imgShow-item{

        width:3.5rem;
        height:3.5rem;
        padding:0.2rem;
        margin-left: 5px;
        display: inline-block;
        img{
          width:100%;
          height:100%;
        }
      }

      .bottom1{
        margin-top: 10px;
        overflow:hidden;
        .classify{
          float:left;
        }
        .option{
          float:right;
          overflow:hidden;
          .browse{
            float:left;
          }
        }
      }
    }
  }
  .sizeStyle{
    font-weight:bold;
    color:black
  }
</style>



// WEBPACK FOOTER //
// src/components/adminInfoView.vue